// 9fbef606107a605d69c0edbcd8029e5d
import { all } from 'redux-saga/effects';
import BootstrapSaga from '@tcp/core/src/reduxStore/sagas/bootstrap';
import LabelsSaga from '@tcp/core/src/reduxStore/sagas/labels';
import SEODataSaga from '@tcp/core/src/reduxStore/sagas/seoData';
import LayoutSaga from '@tcp/core/src/reduxStore/sagas/layout';
import SearchPageSaga from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.saga';
import UserSaga from '@tcp/core/src/components/features/account/User/container/User.saga';
import GiftCardBalanceSaga from '@tcp/core/src/components/features/account/Payment/container/GetCardBalance.saga';
import ProductListingSaga from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import CategoryListingPageSaga from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.saga';
import HorizontalCategorySaga from '@tcp/core/src/components/features/browse/HorizontalCategory/container/HorizontalCategory.saga';
import NavigationSaga from '@tcp/core/src/components/features/content/Navigation/container/Navigation.saga';
import ProductDetailSaga from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.saga';
import QuickViewSaga from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.saga';
import BagPageSaga from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.saga';
import BrandTabs from '@tcp/web/src/components/features/content/Header/molecules/BrandTabs/container/BrandTabs.saga';
import StyliticsProductTabListSaga from '@tcp/core/src/components/common/organisms/StyliticsProductTabList/container/StyliticsProductTabList.saga';
import RecommendationsSaga from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.saga';
import StoreLocatorSaga from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.saga';
import StoreDetailSaga from '@tcp/core/src/components/features/storeLocator/StoreDetail/container/StoreDetail.saga';
import OutfitDetailsSaga from '@tcp/core/src/components/features/browse/OutfitDetails/container/OutfitDetails.saga';
import NavigateXHRSaga from '@tcp/core/src/components/features/account/NavigateXHR/container/NavigateXHR.saga';
import FavoriteSaga from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.saga';
import SearchBarSaga from '@tcp/core/src/components/common/molecules/SearchBar/SearchBar.saga';
import BundleProductSaga from '@tcp/core/src/components/features/browse/BundleProduct/container/BundleProduct.saga';
import AbtestSaga from '@tcp/core/src/components/common/molecules/abTest/abTest.saga';
import AnalyticsSaga from '@tcp/core/src/analytics/Analytics.saga';
import PromotionsSaga from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.saga';
import BossUnavailableSaga from '@tcp/core/src/components/features/CnC/CartItemTile/molecules/BossUnavailableTile/container/BossUnavailable.saga';
import DynamicSizeChartSaga from '@tcp/core/src/components/common/molecules/DynamicSizeChart/container/DynamicSizeChart.saga';
import InYourBagSaga from '@tcp/core/src/components/features/browse/InYourBag/container/InYourBag.saga';
import AddPickupPersonSaga from '@tcp/core/src/components/features/account/OrderDetails/organism/AddPickupPerson/container/AddPickUpPersonForm.saga';
import CountrySelectorSaga from '@tcp/web/src/components/features/content/HeaderNew/molecules/CountrySelector/container/CountrySelector.saga.js';
import AdyenPaymentSaga from '@tcp/core/src/components/common/organisms/AdyenPayment/container/AdyenPayment.saga';
import ShopByLookStyliticsSaga from '@tcp/core/src/components/common/molecules/ShopByLookStylitics/container/ShopByLookStylitics.saga';
import SiteMapSaga from '../../components/features/content/SiteMap/container/SiteMap.saga';

export default function* rootSaga() {
  yield all([
    BootstrapSaga(),
    LabelsSaga(),
    SEODataSaga(),
    LayoutSaga(),
    UserSaga(),
    SearchBarSaga(),
    GiftCardBalanceSaga(),
    BagPageSaga(),
    ProductListingSaga(),
    ProductDetailSaga(),
    StyliticsProductTabListSaga(),
    RecommendationsSaga(),
    StoreLocatorSaga(),
    SearchPageSaga(),
    StoreDetailSaga(),
    NavigateXHRSaga(),
    OutfitDetailsSaga(),
    BundleProductSaga(),
    NavigationSaga(),
    SiteMapSaga(),
    AbtestSaga(),
    AnalyticsSaga(),
    PromotionsSaga(),
    QuickViewSaga(),
    CategoryListingPageSaga(),
    HorizontalCategorySaga(),
    InYourBagSaga(),
    FavoriteSaga(),
    BrandTabs(),
    BossUnavailableSaga(),
    DynamicSizeChartSaga(),
    AddPickupPersonSaga(),
    CountrySelectorSaga(),
    AdyenPaymentSaga(),
    ShopByLookStyliticsSaga(),
  ]);
}
